import { tr } from '~/assets/scripts/helpers'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, context) => {
    if (!window._error_logged) {
      window._error_logged = true
      $api('/api/logs/error', {
        method: 'POST',
        body: {
          error: error ? `${error.message}\n${error.stack}`.trim() : 'undefined',
          view: context && context.$el ? context.$el.baseURI : null,
        },
      }).then((_) => {
        try {
          nuxtApp.$toast.error(
            tr(
              'An error has been encountered. Please reload the page, or contact support if the error persists',
            ),
            {
              duration: 10000,
            },
          )
        } catch (e) {
          console.error(e)
        }
      })
    }
    throw error
  }
})
